import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";
import "../TotalReportAnalysis/TotalReportAnalysis.css";

// Sample data
const data = [
  { date: "Daily", reports: 7000 },
  { date: "Weekly", reports: 5000 },
  { date: "Monthly", reports: 3000 },
];

const colors = ["#a5bcfc", "#c7d7fe", "#dcdcdc"];

const CustomBar = (props) => {
  const { fill, x, y, width, height, index } = props;
  const radius = 5;

  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const TotalReportAnalysis = () => {
  const [chartHeight, setChartHeight] = useState(330);

  // Adjust height based on screen width
  useEffect(() => {
    const updateHeight = () => {
      setChartHeight(window.innerWidth <= 1300 ? 280 : 330);
    };

    updateHeight(); // Set initial height
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <section className="section">
      <div className="report-container">
        <div className="report-header">
          <h1>Total Reports Published & Their Status Analysis</h1>
        </div>

        <div className="report-parent">
          <div className="report-count-wrapper">
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#a5bcfc" }}></i>{" "}
              Daily
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#c7d7fe" }}></i>{" "}
              Weekly
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#dcdcdc" }}></i>{" "}
              Monthly
            </div>
          </div>

          <div className="report-chart-container">
            <ResponsiveContainer width="100%" height={chartHeight}>
              <BarChart
                data={data}
                margin={{ top: 10, right: 30, left: 10, bottom: 20 }}
              >
                <CartesianGrid
                  stroke="#d6d6d6"
                  strokeDasharray="0 0"
                  horizontal={true}
                  vertical={false}
                />

                <XAxis
                  dataKey="date"
                  tick={{ fontSize: 14, fill: "#999" }}
                >
                  <Label
                    value="Time Period"
                    position="insideLeft"
                    offset={0}
                    style={{ fontSize: "14px", fill: "#999" }}
                    dy={25}
                  />
                </XAxis>

                <YAxis
                  tick={{ fontSize: 14, fill: "#999" }}
                >
                  <Label
                    value="Number of Reports"
                    angle={-90}
                    position="insideBottom"
                    style={{ fontSize: "14px", fill: "#999" }}
                    dy={-55}
                    dx={-28}
                  />
                </YAxis>

                <Tooltip
                  cursor={{ fill: "transparent" }}
                  formatter={(value) => [`${value}k`, "Reports (Count)"]}
                  labelStyle={{
                    fontSize: "14px",
                    color: "#000",
                  }}
                  itemStyle={{
                    fontSize: "14px",
                    color: "#999",
                  }}
                />

                <Bar
                  dataKey="reports"
                  shape={(props) => {
                    const color = colors[props.index % colors.length];
                    return <CustomBar {...props} fill={color} />;
                  }}
                  barSize={window.innerWidth < 1400 ? 30 : 50}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TotalReportAnalysis;
